

import CommonButton from '~/components/common/button/CommonButton.vue'
import { commonfunc } from '~/mixin/common'
import { pdMixin } from '@/mixin/pd/pdMixin'

export default {
  components: {
    CommonButton
  },
  mixins: [commonfunc, pdMixin],
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    geolocationAgrYn: {
      type: String,
      default: 'N'
    },
    sleStsCd: {
      type: String,
      default: ''
    },
    interestYn: {
      type: Boolean,
      default: false
    },
    storeLocationYn: {
      type: Boolean,
      default: false
    },
    selectedIndex: {
      type: [String, Number],
      default: null
    },
    isListType: {
      type: Boolean,
      default: false
    },
    recentDvya: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isAddPkup: {
      type: Boolean,
      default: false
    },
    isMbc: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      unitRole: 'presentation',
    }
  },
  created () {
    if (this.isListType) {
      this.unitRole = 'button'
    }
  },
  methods: {
    changeSelect (idx) {
      this.$emit('change-select', idx)
    },
    btnClick (item) {
      this.$emit('btn-click', item.strCd, item)
    },
  }
}
